<template>
	<div class="sy-ch-main container-fluid container500 relative" id = "wholeContainer">
		<div class="text-right">
			<div class="ib notification">
				<i ref = "enableNotification">
					<audio id = "orderNotificationPlayer" loop >
						<source src="/static/sounds/notification.mp3" type="audio/mp3"></source>
					</audio>
				</i>
			</div>
		</div>
		<div class="sy-ch-search mb3 mt2">
			<input class="form-control" type="text" name="" value="" :placeholder="copywriting[language]['Search by Order ID/ Name/ Email/ Contact Number']" v-model = "searchTerm"  v-on:keyup.enter = "search(searchTerm)">
			<button class="sy-se-icon" @click = "search(searchTerm)"><img src="../../static/img/search.png" width="18" alt=""></button>
		</div>
		<div style="display: none;">
			<a data-fancybox href="#search-result"></a>
			<div id="search-result" class="popup-content">
				<div class="po-co-main">
					<div style = "cursor: pointer; text-align: center;" @click = "back">
						<h1>{{copywriting[language]['Back to Orders']}}</h1>
					</div>
					<h1>{{copywriting[language]['Search results']}}</h1>
					<div :class="{'order': true, 'mb2': true, 'green': order.Redeemed, 'red': order.Status === 'Error', 'blue': !order.Redeemed && order.Status !== 'Error'}" v-for = "order in searchedOrder">
						<div class="order-head fz-16">
							<div class="fz-14">
								{{copywriting[language]['Order No.']}}
							</div>
							<div class="bold">
								{{order["Order ID"]}}
							</div>
							<div class="separator"></div>
							<div class="bold">{{copywriting[language][order["Collection Mode"] || "Pickup"]}}</div>
							<div class="separator"></div>
							<div class="bold text-right">{{formatTimeComplex(order)}}</div>
						</div>
						<div class="order-content fz-14">
							<strong>{{order.Name}} ( <a class="fz-18" :href="'tel:' + order['Contact Number']">{{order["Contact Number"]}}</a> )</strong>
							<br>
							<div class="address mt-5" v-if = "order['Collection Mode'] === 'Delivery'">
								{{copywriting[language]['Unit / House / Block Number']}}: {{order["House Number"]}}
								<br>
								{{order["Address"]}}
							</div>
							<div class="email mt-5">
								{{order["Email"]}}
							</div>
							<div class="email mt-5" v-if = "order['Collection Mode'] === 'Dine In'">
								{{order["nPax"]}} Pax
							</div>
							<div class="email" style="word-break:break-all;" v-if = "order.Remarks">
								{{copywriting[language]['Remarks']}}: {{order["Remarks"]}}
							</div>
							<div class="email" style="word-break:break-all;" v-if = "order['CS to Merchant']">
								{{copywriting[language]['Remarks']}}: {{order["CS to Merchant"]}}
							</div>
							<template v-if = "order['Collection Mode'] === 'Delivery'">
								<div class="divider"></div>
								{{copywriting[language]['Scheduled Delivery']}}:
								<br>
								<div class="delivery-type mt-5" v-if = "order['Delivery Info']">
									{{order["Delivery Mode"] == "MrSpeedy" ? "Borzo" : order["Delivery Mode"]}} ({{copywriting[language]['Contact Number']}}: <a :href="'tel:' + phoneNums[order['Delivery Info'].Type]">{{phoneNums[order["Delivery Info"].Type]}}</a>)
								</div>
								<template v-if = "order['Delivery Info'] != undefined">
									<div class="delivery-status mt-5">
										<div class="status yellow ib mr5"></div><div class="ib">{{order["Delivery Info"]["Status"]}} (Delivery Order No. {{order["Delivery Info"]["Delivery ID"]}})</div>
									</div>
									<div class="driver mt-5">
										<strong>{{copywriting[language]['Rider/Driver']}}: {{order["Delivery Info"]["dName"]}} ( <a class="fz-18" :href="'tel:' + order['Delivery Info']['dContact Number']">{{order["Delivery Info"]["dContact Number"]}}</a> )</strong>
									</div>
								</template>
							</template>
							<div class="divider"></div>
							<div class="order-summary fz-16">
								<table class="full">
									<tr>
										<td>
											<strong>{{copywriting[language]['Order Summary']}}</strong>
										</td>
										<td>
											<strong>{{copywriting[language]['Units']}}</strong>
										</td>
										<td class="text-right"></td>
									</tr>
									<tr v-for = "item in order.Items">
										<td>
											{{item.Name}}
											<div class="options" v-html = "generateHTML(item)">

											</div>
										</td>
										<td>
											x {{item.Quantity}}
										</td>
										<td class="text-right">
											{{formatPrice(item['Total'] || item.Quantity*item.Price, "")}}
										</td>
									</tr>
									<!-- SPACING -->
									<tr>
										<td class="">
											<br><br><br>
										</td>
									</tr>
									<!-- SPACING END -->
									<tr>
										<td class="text-right" colspan="2">
											{{copywriting[language]['Delivery Fee']}}:
										</td>
										<td class='text-right'>
											{{formatPrice(order["Delivery Fee"] || 0)}}
										</td>
									</tr>
									<tr>
										<td class="text-right bold" colspan="2">
											{{copywriting[language]['Total']}}:
										</td>
										<td class='text-right bold'>
											{{formatPrice(order["Total"] || 0)}}
										</td>
									</tr>
									<tr>
										<td colspan="3" class="order-receive">
											{{copywriting[language]['Order']}}: [{{formatDate(order["Date Created"])}}] [{{formatTime(order["Date Created"])}}]
										</td>
									</tr>
								</table>
							</div>
						</div>
						<!-- <div class="order-footer">
							<div class="text-left">
								<div class="btn-order-footer btn-error" @click = "setError(order)">
									{{copywriting[language]['Error']}}
								</div>
								<div class="btn-order-footer btn-pdf">
									PDF
								</div>
							</div>
							<div class="text-right"@click = "redeem(order)">
								<div class="btn-order-footer btn-done" >
									{{copywriting[language]['Done']}}
								</div>
							</div>
							<div class="clr"></div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="button mb3">
			<div class="internal">

				<!-- Purchase > Today > Completed > Upcoming > History -->
				<div :class="{'btn-toggle': true, 'mr7': true, 'active': viewMode === 'Purchases'}" @click = "viewMode = 'Purchases'; searchTerm = ''">
					{{copywriting[language]['Purchase']}}
					<div class="number" v-if = "Purchases.length>0">{{Purchases.length}}</div>
				</div>
				<div :class="{'btn-toggle': true, 'mr7': true, 'active': viewMode === 'Today'}" @click = "viewMode = 'Today'; searchTerm = ''; stopSound();">
					{{copywriting[language]['Today']}}
					<div class="new" v-if = "oldTodayOrders.some(r=>{return !localOrders.includes(r)})">{{copywriting[language]['NEW']}}</div>
					<div class="number" v-if = "oldTodayOrders.length>0">{{oldTodayOrders.length}}</div>
				</div>
				<div :class="{'btn-toggle': true, 'mr7': true, 'active': viewMode === 'Completed'}" @click = "viewMode = 'Completed'; searchTerm = ''">
					{{copywriting[language]['Completed']}}
				</div>
				<div :class="{'btn-toggle': true, 'mr7': true, 'active': viewMode === 'Upcoming'}" @click = "viewMode = 'Upcoming'; searchTerm = ''">
					{{copywriting[language]['Upcoming']}}
				</div>
				<div :class="{'btn-toggle': true, 'mr7': true, 'active': viewMode === 'History'}" @click = "viewMode = 'History'; searchTerm = ''">
					{{copywriting[language]['History']}}
				</div>
			</div>
		</div>
		<template v-if = "viewMode === 'History'">
			<HistoryComp class=""></HistoryComp>
		</template>
		<template v-else  v-for = "(dayOrders, date) in getOrders(viewMode, sortedOrders, sortedPurchases)">
			<div class="order-listing" v-if = "filterDate(date, dayOrders)">
				<h1 class = "mb1">{{date}}, {{copywriting[language][weekdays[new Date(date+' '+new Date().getFullYear()).getDay()]]}} </h1>
				<div :class="{'order': true, 'mb2': true, 'green': order.Redeemed, 'red': order.Status === 'Error', 'blue': !order.Redeemed && order.Status !== 'Error'}" v-for = "order in dayOrders" v-if = "filterItem(order, searchTerm)">
					<div class="btn-toggle" style = "width: 0px; height: 0px; padding:0px;"v-if = "order['Collection Mode'] != 'Purchase' && !localOrders.includes(order['.key']) && date === todayString">
						<div class="new" >NEW</div>
					</div>
					<div class="order-head fz-16">
						<div class = "bold">
							<span class = "fz-18">
								{{formatDate(order.Date)}}, {{copywriting[language][weekdays[new Date(order.Date).getDay()]]}}
							</span>
							<br>
							<span class = "fz-16">
								{{formatTimeComplex(order)}}
							</span>
							<br>
							<div class="order-type fz-12 mt-1">{{copywriting[language][order["Collection Mode"] || "Pickup"]}}</div>
						</div>
						<div class = "text-right">
							<span class="fz-12">
								{{copywriting[language]['Order No.']}}
							</span>
							<br>
							<h4 class="bold">
								{{order["Order ID"]}}
							</h4>
						</div>
					</div>
					<div class="order-content fz-14">
						<strong>{{order.Name}} ( <a class="fz-18" :href="'tel:' + order['Contact Number']">{{order["Contact Number"]}}</a> )</strong>
						<br>
						<div class="address" v-if = "['Delivery', 'Purchase'].includes(order['Collection Mode'])">
							{{copywriting[language]['Unit / House / Block Number']}}: {{order["House Number"]}}
							<br>
							{{order["Address"]}}
						</div>
						<div class="email">
							{{order["Email"]}}
						</div>
						<div class="email" v-if = "order['Collection Mode'] === 'Dine In'">
							{{order["nPax"]}} Pax
						</div>
						<div class="email" style="word-break:break-all;" v-if = "order.Remarks">
							{{copywriting[language]['Remarks']}}: {{order["Remarks"]}}
						</div>
						<div class="email" style="word-break:break-all;" v-if = "order['CS to Merchant']">
							{{copywriting[language]['Remarks']}}: {{order["CS to Merchant"]}}
						</div>
						<template v-if = "order['Collection Mode'] === 'Delivery'">
							<div class="divider"></div>
							{{copywriting[language]['Scheduled Delivery']}}:
							<br>
							<div class="delivery-type">
								{{order["Delivery Mode"] == "MrSpeedy" ? "Borzo" : order["Delivery Mode"]}} ({{copywriting[language]['Contact Number']}}: <a :href="'tel:' + phoneNums[(order['Delivery Info'] || {Type: ''}).Type]">{{phoneNums[(order["Delivery Info"] || {Type: ''}).Type]}}</a>)
							</div>
							<template v-if = "order['Delivery Info'] != undefined">
								<div class="delivery-status">
									<div class="status yellow ib mr5"></div>
									<div class="ib delivery-info">{{order["Delivery Info"]["Status"]}} (Delivery Order No. {{order["Delivery Info"]["Delivery ID"]}})</div>
								</div>
								<div class="driver">
									<strong>{{copywriting[language]['Rider/Driver']}}: {{order["Delivery Info"]["dName"]}} (<a class="fz-18" :href="'tel:' + order['Delivery Info']['dContact Number']">{{order["Delivery Info"]["dContact Number"]}}</a>)</strong>
								</div>
							</template>
						</template>
						<div class="divider"></div>
						<div class="order-summary fz-16">
							<table class="full">
								<tr>
									<td>
										<strong>{{copywriting[language]['Order Summary']}}</strong>
									</td>
									<td>
										<strong>{{copywriting[language]['Units']}}</strong>
									</td>
									<td class="text-right"></td>
								</tr>
								<tr v-for = "item in order.Items">
									<td>
										{{item.Name}}
										<div class="options" v-html = "generateHTML(item)">

										</div>
									</td>
									<td>
										x {{item.Quantity}}
									</td>
									<td class="text-right">
										{{formatPrice(item['Total'] || item.Quantity*item.Price, "")}}
									</td>
								</tr>
								<!-- SPACING -->
								<tr>
									<td class="">
										<br><br><br>
									</td>
								</tr>
								<!-- SPACING END -->
								<tr v-if = "['Delivery', 'Purchase'].includes(order['Collection Mode'])">
									<td class="text-right" colspan="2">
										{{copywriting[language]['Delivery Fee']}}:
									</td>
									<td class='text-right'>
										{{formatPrice(order["Delivery Fee"] || 0)}}
									</td>
								</tr>
								<tr v-for = "c in order.Commissions">
									<td class="text-right" colspan="2">
										{{c["Commission Name"]}}:
									</td>
									<td class='text-right'>
										{{formatPrice(c.Total || 0)}}
									</td>
								</tr>
								<tr v-if = "order['Discount'] > 0">
									<td class="text-right" colspan="2">
										{{copywriting[language]['Discount']}}:
									</td>
									<td class='text-right'>
										{{formatPrice(order['Discount'] || 0)}}
									</td>
								</tr>
								<tr v-if = "order['Dine In Tax'] > 0">
									<td class="text-right" colspan="2">
										{{copywriting[language]['Dine In Tax']}}:
									</td>
									<td class='text-right'>
										{{formatPrice(order['Dine In Tax'] || 0)}}
									</td>
								</tr>
								<tr v-if = "order['Promo Discount'] > 0">
									<td class="text-right" colspan="2">
										{{copywriting[language]['Promo Code']}}:
										<br>
										({{order["PromoCode"]}})
									</td>
									<td class='text-right'>
										{{formatPrice(order['Promo Discount'] || 0)}}
									</td>
								</tr>
								<tr>
									<td class="text-right bold" colspan="2">
										{{copywriting[language]['Total']}}:
									</td>
									<td class='text-right bold'>
										{{formatPrice(order["Total"] || 0)}}
									</td>
								</tr>
								<tr>
									<td colspan="3" class="order-receive">
										{{copywriting[language]['Order']}}: [{{formatDate(order["Date Created"])}}] [{{formatTime(order["Date Created"])}}]
									</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="order-footer">
						<div class="text-left">
							<!-- <div class="btn-order-footer btn-error" @click = "setError(order)">
								{{copywriting[language]['Error']}}
							</div> -->
							<div class="btn-order-footer btn-pdf" @click = "sendPushNotification(order)">
								Print
							</div>
						</div>
						<div class="text-right"@click = "redeem(order)">
							<div class="btn-order-footer btn-done" >
								{{copywriting[language]['Done']}}
							</div>
						</div>
						<div class="clr"></div>
					</div>
				</div>
			</div>
			<div v-else-if = "viewMode === 'Today' && date === todayString">
				<h1 class = "mb1">{{copywriting[language]['All orders are completed!']}}</h1>
			</div>
		</template>
		<div class="floating-button" @click = "scrollToBottom">&#8595;</div>
	</div>
</template>
<style scoped>
.floating-button{
	background-color: #0A84FF;
	position: fixed;
	width: 50px;
	height: 40px;
	left: 50%;
	margin-left: -25px; /* Negative half of width. */
	bottom:  84px;
	color:  white;
	font-size:  24px;
	font-weight:  900;
	border-radius: 10px 10px 0 0;
	text-align: center;
	cursor:  pointer;
}
</style>
<script>
import HistoryComp from "./HistoryComp";
var dbPath = "";
export default{
	components:{
		HistoryComp
	},
	data(){
		this.$store.commit("loadState", this.$route.params.businessID);
		return{
			copywriting: copywriting,
			language: this.$store.getters.getLanguage(),
			orders: [],
			sortedOrders: {},
			todayOrders: [],
			// tomorrowOrders: [],
			allOrders: this.$parent.allOrders,
			allSortedOrders: {},
			searching: false,
			searchTerm: "",

			searchedOrder: {},
			viewMode: "Today",
			weekdays: myDate.weekdays,
			todayString: myDate.displayCurrentDate({sequence: "d m", monthMode: 2}),
			deliveries: [],
			firstCheck: true,

			oldTodayOrders: [],
			hasNewOrder: false,
			newOrders: [],

			phoneNums:{
				"GoGet": "",
				"Mula": "0376616262",
				"MrSpeedy": "0327247117",
			},

			localOrders: this.$store.getters.getOrders(),
			Purchases: [],
			sortedPurchases: {},
			autoPrintDoc: {},

			reachedEnd: false,
			showButton: true

		}
	},
	firestore(){
		var today = new Date();
		today.setSeconds(0);
		today.setMinutes(0);
		today.setHours(0);
		var todayTime = today.getTime();
		var tomorrowTime = todayTime + 24*60*60*1000;
		let bID = this.$route.params.businessID;
		dbPath = "business/" + bID + "/preorders";
		this.$binding("autoPrintDoc", myFB.db.collection("business/" + bID + "/settings").doc("autoPrint"));
		this.$binding("Purchases", myFB.db.collection(dbPath).orderBy("Date").where("Paid", "==", true).where("Redeemed", "==", false).where("Collection Mode", "==", "Purchase")).then(g=>{
			this.sortOrders();
		})
		this.$binding("todayOrders", myFB.db.collection(dbPath).orderBy("Date").where("Date",">=", todayTime).where("Paid", "==", true)).then(g=>{
			this.$binding("deliveries", myFB.db.collection("business/" + bID + "/deliveries").orderBy("deliveryDate").where("deliveryDate",">=", todayTime)).then(g=>{
				this.sortOrders();
				customJS.runAll();	
				var oldTodayOrders = this.todayOrders.filter(r=>{
					return !r.Redeemed && myDate.displayDate(r.Date, {sequence: "d m", monthMode: 2}) === this.todayString;
				});
				this.oldTodayOrders = oldTodayOrders.map(r=>{
					return r[".key"];
				});
			})
		});
	},
	watch:{
		todayOrders: function(){
			this.firstCheck = false;
			this.sortOrders();
			var oldTodayOrders = this.todayOrders.filter(r=>{
				return !r.Redeemed && myDate.displayDate(r.Date, {sequence: "d m", monthMode: 2}) === this.todayString;
			});
			this.oldTodayOrders = oldTodayOrders.map(r=>{
				return r[".key"];
			});
			this.checkSound();
		},
		Purchases(){
			this.sortOrders();
		},
		deliveries: function(){
			this.sortOrders();
		},
		"$parent.allOrders": function(){
			this.allOrders = this.$parent.allOrders;
		}
	},
	mounted(){
		var w=0;
		var elems = $('.internal .btn-toggle'), count = elems.length;
		elems.each(function(){
			// console.log($(this).width());
			w+=$(this).width();
			if (!--count){
				$('.internal').width( w + (38*elems.length) );
			}
		})
	},
	methods:{
		//--------------------- NOTIFICATION ----------------------//
		checkSound(){
			setTimeout(()=>{

				if (this.oldTodayOrders.some(r=>{return !this.localOrders.includes(r)})){
					this.$refs.enableNotification.click();
					myNotify.startSound();
				}
				else{
					this.stopSound();
				}
			}, 3000);
		},
		stopSound(){
			myNotify.stopSound();
			this.$store.commit("updateOrders", {
				orders: this.oldTodayOrders,
				bID: this.$route.params.businessID
			});
			this.$store.commit("loadState", this.$route.params.businessID);
			this.localOrders = this.$store.getters.getOrders();
		},
		sendPushNotification(orderDat){
			this.autoPrintDoc.mobileFCMToken.forEach(token=>{
				let data = {
					title: "other.kitchen Order " + orderDat["Order ID"] + " (RM" + orderDat.Total.toFixed(2) + ")",
					body: "Order for " + orderDat.Name,
					token,
					click_action: "FLUTTER_NOTIFICATION_CLICK",
					data: JSON.stringify({
						"Business Name": orderDat["Business Name"],
						"Order ID": orderDat["Order ID"],
						"Collection Mode": orderDat["Collection Mode"],
						"Date": orderDat["Date"],
						"Contact Number": orderDat["Contact Number"],
						"Email": orderDat["Email"],
						"House Number": orderDat["House Number"],
						"Address": orderDat["Address"],
						"Items": orderDat["Items"].map(r=>{
							return{
								custom: r.custom,
								Name: r.Name,
								Quantity: r.Quantity,
								Price: r.Price,

							}
						}),
						"Name": orderDat["Name"],
						"Remarks": orderDat["Remarks"],
						"Subtotal": orderDat["Subtotal"],
						"Delivery Fee": orderDat["Delivery Fee"],
						"Booking Fee": orderDat["Booking Fee"],
						"Tax": orderDat["Tax"],
						"Dine In Tax": orderDat["Dine In Tax"],
						"Discount": orderDat["Discount"],
						"Promo Discount": orderDat["Promo Discount"],
						"Payment Method": orderDat["Payment Method"],
						"Date Created": orderDat["Date Created"],
						"Total": orderDat["Total"]
					})
				}
				let message = {
					data: {
						order: data.data,
						title: data.title,
						body: data.body
					},
					android:{
						data: {
							order: data.data,
							title: data.title,
							body: data.body
						}
					},
					token: data.token
				}
				myFB.functions.httpsCallable("sendPushNotification")({
					data: message,
					bID: this.$route.params.businessID
				}).then(r=>{
					console.log(r);
				})
			})
		},
		//------------------------ DISPLAY ------------------------//
		generateHTML(item){
			var i = myCopier.copy(item);
			var code = "";
			if (item.custom != undefined && item.custom.length > 0){
				code += "<div style = \"padding-left: 5px;\">\n";
				item.custom.forEach((c, cIndex)=>{
					code += (cIndex+1) + ": \n";
					code += "<div style = \"padding-left: 5px;\">\n";
					for (var optionIndex in c){
						var option = c[optionIndex];
						if (option.length > 0){
							code += "<li>- " + optionIndex + ": \n";
							option.forEach((choice, choiceIndex)=>{
								code += "<span>\n" + choice + "\n";
								if (choiceIndex < option.length-1){
									code += "<span>, </span>\n";
								}
								code += "</span>\n";
							});
							code += "</li>\n";
						}
					}
					code += "</div>\n"
				})
				code += "</div>\n";
			}
			return code;
		},
		//------------------------ DISPLAY ------------------------//
		formatTimeComplex(input){
			if (["Delivery", "Dine In"].includes(input["Collection Mode"])){
				return myDate.displayTime(input.Date,
				{
					hourFormat: 12,
					sequence: "hh:mm",
				}) + " - " + myDate.displayTime(input.Date + 60*60*1000,
				{
					hourFormat: 12,
					sequence: "hh:mm",
				})
			}
			else{
				return myDate.displayTime(input.Date,
				{
					hourFormat: 12,
					sequence: "hh:mm",
				})
			}
		},
		formatTime(input){
			return myDate.displayTime(input,
			{
				hourFormat: 12,
				sequence: "hh:mm",
			})
		},
		formatDate(input){
			return myDate.displayDate(input,
			{
				sequence: "d/m/y",
			})
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		//------------------------ FILTERS ------------------------//
		getOrders(viewMode, sortedOrders, Purchases){
			if (viewMode != "Purchases"){
				return sortedOrders;
			}
			return Purchases;
		},
		filterDate(date, orders){
			if (this.viewMode === "Today"){
				var hasOrder = this.todayString === date && orders.some(r=>{
					return this.filterItem(r, this.searchTerm);
				});
				return hasOrder;
			}
			else if (this.viewMode === "Upcoming"){
				return this.todayString !== date && orders.some(r=>{
					return this.filterItem(r, this.searchTerm);
				})
			}
			else{
				return orders.some(r=>{
					return this.filterItem(r, this.searchTerm);
				})
			}
			return orders.length>0;
		},
		filterItem(order, text){
			var showCond = JSON.stringify(order).toUpperCase().includes(text.toUpperCase());
			if (this.viewMode === "Completed"){
				return order.Redeemed && showCond;
			}
			else if (this.viewMode === "Error"){
				return order.Status === "Error" && showCond;
			}
			else{
				return !order.Redeemed && showCond;
			}
			return showCond;
		},


		//------------------------ SORTING ------------------------//
		sortOrders(){
			var today = new Date();
			today.setSeconds(0);
			today.setMinutes(0);
			today.setHours(0);
			var todayTime = today.getTime();

			var sortedOrders = {};
			var sortedPurchases = {};
			var dateNow = "";
			var deliverySorter = function(input){
				if (input["tracking_url"] != undefined){
					var itemForm = myCopier.copy(input);
					delete itemForm[".key"];
					if (itemForm.gogetters.length<=0){
						itemForm.gogetters = [{
							name: "",
							"phone_num": "",
						}]
					}
					return {
						"Date Created": itemForm["posted_at"],
						"Date": itemForm["start_at"],
						"Order ID": itemForm["reference"],
						"Delivery ID": itemForm["id"],
						"Customer Address": itemForm["tasks"][1]["location"],
						"Name": itemForm["tasks"][1]["recipient_name"],
						"Contact Number": itemForm["tasks"][1]["recipient_phone_num"],
						"dName": itemForm["gogetters"][0]["name"],
						"dContact Number": itemForm["gogetters"][0]["phone_num"],
						"Total": itemForm["Total"],
						"Delivery Fee": itemForm["delivery_fee_amount"],
						"Status": itemForm["status"],
						Type: "Go Get",
					};
				}
				else if (["Mula", "Occam Partner"].includes(input["Type"])){
					var itemForm = myCopier.copy(input);
					return {
						"Date Created": itemForm["posted_at"],
						"Date": itemForm["Pickup Date"],
						"Order ID": itemForm["Order ID"],
						"Delivery ID": itemForm[".key"],
						"Customer Address": itemForm["Customer"]["Address"],
						"Name": itemForm["Customer"]["Name"],
						"Contact Number": itemForm["Customer"]["Contact Number"],
						"dName": itemForm["Driver"]["name"],
						"dContact Number": itemForm["Driver"]["Contact Number"],
						"Total": itemForm["Total"],
						"Delivery Fee": itemForm["Delivery Fee"],
						"Status": itemForm["Status"],
						Type: "Mula",
					};

				}
				else{
					var items = [];
					var itemForm = myCopier.copy(input);
					itemForm.points[1].packages.forEach(p=>{
						items.push({
							"Name": p["ware_code"],
							"Description": p["description"],
							"Quantity": p["items_count"],
							"Price": parseFloat(p["item_payment_amount"])
						})
					})
					if (itemForm.courier == null){
						itemForm.courier = {
							name: "",
							phone: "",
						}
					}

					return {
						"Date Created": itemForm["created_datetime"],
						"Date": itemForm["points"][0]["required_start_datetime"],
						"DateEnd": itemForm["points"][0]["required_finish_datetime"],
						"Order ID": itemForm["points"][1]["client_order_id"],
						"Delivery ID": itemForm["order_id"],
						"Customer Address": itemForm["points"][1]["address"],
						"Name": itemForm["points"][1]["contact_person"]["name"],
						"Contact Number": itemForm["points"][1]["contact_person"]["phone"],
						"dName": itemForm["courier"]["name"],
						"dContact Number": itemForm["courier"]["phone"],
						"Total": itemForm["Total"],
						"Delivery Fee": itemForm["delivery_fee_amount"],
						"Status": itemForm["status"],
						Type: "MR Speedy",
					};
				}
			}

			var deliveriesByOrderID = {};
			this.deliveries.forEach(d=>{
				var currentDelivery = deliverySorter(d);
				deliveriesByOrderID[currentDelivery["Order ID"]]= currentDelivery;
			})
			this.Purchases.forEach(r=>{
				dateNow = myDate.displayDate(r["Date Created"],{sequence: "d m", monthMode: 2})
				if (sortedPurchases[dateNow] == undefined){
					sortedPurchases[dateNow] = [r];
				}
				else{
					sortedPurchases[dateNow].push(r);
				}
			})
			this.todayOrders.forEach(r=>{
				dateNow = myDate.displayDate(r.Date,{sequence: "d m", monthMode: 2})
				if (deliveriesByOrderID[r["Order ID"]] != undefined){
					r["Delivery Info"] = deliveriesByOrderID[r["Order ID"]];
				}
				if (sortedOrders[dateNow] == undefined){
					sortedOrders[dateNow] = [r];
				}
				else{
					sortedOrders[dateNow].push(r);
				}
			})

			this.sortedOrders = myCopier.copy(sortedOrders);
			this.sortedPurchases = myCopier.copy(sortedPurchases);
		},
		redeem(order){
			var allowAdd = false;
			var update = {
				Redeemed: !order.Redeemed,
				redeemTime: myDate.getTime(),
				Status: "Redeemed"
			}
			if (!order.Paid && !order.Redeemed){
				if (confirm("Confirm payment is collected?")){
					allowAdd = true;
					update.Paid = true;
				}
			}
			else if (confirm("Confirm order is collected?")){
				allowAdd = true;
			}
			if (allowAdd){
				myFB.db.collection(dbPath).doc(order['.key']).update(update)
			}
		},
		setError(order){
			var allowAdd = false;
			var update = {
				Status: "Error"
			}
			if (order.Status === "Error" && confirm("Remove error?")){
				update.Status = myFB.fieldVal.delete();
				myFB.db.collection(dbPath).doc(order['.key']).update(update)
			}
			else if (confirm("Confirm order has an error?")){
				allowAdd = true;
			}
			if (allowAdd){
				myFB.db.collection(dbPath).doc(order['.key']).update(update)
			}
		},
		deleteOrder(item){
			if (confirm("Confirm deleting order " + item["Order ID"] + " for " + item.Name + "?")){
				myFB.deleteDoc(dbPath, item['.key'], this, "Deleting order " + item["Order ID"] + " for " + item.Name + "...", "Order deleted!");
			}
		},

		search(orderID){
			var foundOrder = false;
			var orderJSON = {};
			var inputType = "Order ID";

			if (orderID.includes("A-") || orderID.includes("O-")){
				inputType = "Order ID";
			}
			else if (orderID.includes("@")){
				inputType = "Email";
			}
			else if (!isNaN(orderID)){
				inputType = "Contact Number";
			}
			else{
				inputType = "Name";
			}
			console.log(inputType)

			var searchedOrder = [];
			this.orders.forEach(r=>{
				if (r[inputType] == orderID){
					foundOrder = true;
					searchedOrder.push(myCopier.copy(r));
				}
			})
			this.todayOrders.forEach(r=>{
				if (r[inputType] == orderID){
					foundOrder = true;
					searchedOrder.push(myCopier.copy(r));
				}
			})
			console.log(searchedOrder);
			if (foundOrder){
				this.searchedOrder = searchedOrder

				this.searching = true;
				$.fancybox.open({
					src: '#search-result',
					animationEffect: 'zoom-in-out',
					clickSlide: false,
					clickOutside: false,
					autoFocus: false,
					touch: false,
					btnTpl: {
						smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' + '<img id = \"closePopup\" src="static/img/close.png" width="15" alt="">' +"</button>"
					},
				});

			}
			else{
				myFB.db.collection(dbPath).where(inputType, "==", orderID).limit(1).get().then(r=>{
					if (r.empty){
						searchedOrder = [];
						this.searchedOrder = searchedOrder
						$.fancybox.open({
							src: '#search-result',
							animationEffect: 'zoom-in-out',
							clickSlide: false,
							clickOutside: false,
							autoFocus: false,
							touch: false,
							btnTpl: {
								smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' + '<img id = \"closePopup\" src="static/img/close.png" width="15" alt="">' +"</button>"
							},
						});
					}
					else{
						var searchedOrder = [];
						var foundOrder = r.docs[0].data()
						foundOrder[".key"] = r.docs[0].id;
						searchedOrder = [foundOrder];
						this.searchedOrder = searchedOrder

						this.searching = true;
						$.fancybox.open({
							src: '#search-result',
							animationEffect: 'zoom-in-out',
							clickSlide: false,
							clickOutside: false,
							autoFocus: false,
							touch: false,
							btnTpl: {
								smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' + '<img id = \"closePopup\" src="static/img/close.png" width="15" alt="">' +"</button>"
							},
						});
					}
				})
			}
		},
		back(){
			this.searching = false;
			this.orderID = "";
			$("#closePopup").click();
			this.searchTerm = "";
		},
		scrollToBottom(){
			this.reachedEnd =  $(window).scrollTop()+ $(window).height() == $(document).height();
			if (this.reachedEnd){
				return window.scrollTo(0, 0);
			}
			window.scrollTo(0, document.getElementById('wholeContainer').scrollHeight)
		},
		calcNOrders(sOrders){
			var num = 0;
			for (var item in sOrders){
				num += sOrders[item].length;
			}
			return num;
		}

	}
};
</script>


// WEBPACK FOOTER //
// src/components/Orders_v2.vue